import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: '8px 16px 16px 35px',
    overflow: 'auto',
    height: 'auto',
  },
  listContainer: {
    padding: 0,
    margin: 0,
    listStyle: 'none',
  },
  listItem: {
    paddingBottom: 24,
    borderLeft: '2px solid #f0f0f0',
    paddingLeft: 8,
    position: 'relative',

    '&:last-child': {
      paddingBottom: 0,
      borderLeft: 0,
      marginTop: -5,

      '&:before': {
        left: -3,
      },
    },
    '&:before': {
      position: 'absolute',
      left: -5,
      top: 5,
      content: "''",
      borderRadius: '500%',
      background: '#fff',
      height: 4,
      width: 4,
      border: '2px solid #f0f0f0',
    },
  },
  year: {
    fontSize: 13,
    lineHeight: 1.54,
    color: '#9ca8b5',
    letterSpacing: 0.24,
  },
  title: {
    fontSize: 14,
    lineHeight: 1.43,
    color: '#49515a',
    letterSpacing: 0.25,
    fontWeight: 500,
  },
  subtitle: {
    fontSize: 13,
    lineHeight: 1.54,
    color: '#60676f',
    letterSpacing: 0.25,
  },
  caption: {
    color: '#9ca8b5',
  },
  subcaption: {
    color: '#9ca8b5',
  },
}));

const MONTH_SHORT = [
  'JAN',
  'FEB',
  'MAR',
  'APR',
  'MAY',
  'JUNE',
  'JULY',
  'AUG',
  'SEPT',
  'OCT',
  'NOV',
  'DEC',
];

const Timeline = ({ list = [], keys = {} }) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <ul className={classes.listContainer}>
        {list.map((item) => {
          const startYear =
            item[keys['startYearParent']][keys['startYear']] === -1
              ? 'Present'
              : item[keys['startYearParent']][keys['startYear']];
          const endYear =
            item[keys['endYearParent']][keys['endYear']] === -1
              ? 'Present'
              : item[keys['endYearParent']][keys['endYear']];

          const startMonth =
            item[keys['startYearParent']][keys['startMonth']] === -1
              ? ''
              : MONTH_SHORT[
                  item[keys['startYearParent']][keys['startMonth']] - 1
                ];
          const endMonth =
            item[keys['endYearParent']][keys['endMonth']] === -1
              ? ''
              : MONTH_SHORT[item[keys['endYearParent']][keys['endMonth']] - 1];

          return (
            <li className={classes.listItem}>
              <Typography classes={{ root: classes.title }}>
                {item[keys['title']]}
              </Typography>
              <Typography classes={{ root: classes.subtitle }}>
                {item[keys['subtitle']]}
              </Typography>
              <Typography
                classes={{ root: clsx(classes.subtitle, classes.caption) }}
              >
                {item[keys['caption']]}
              </Typography>
              <Typography
                classes={{ root: clsx(classes.subtitle, classes.subcaption) }}
              >
                {item[keys['subcaption']]}
              </Typography>
              {startYear || endYear ? (
                <Typography classes={{ root: classes.year }}>
                  {startMonth || ''} {startYear || ''}{' '}
                  {startYear && endYear ? '-' : ''} {endMonth || ''}{' '}
                  {endYear || ''}
                </Typography>
              ) : null}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Timeline;
